import { Model } from 'es6/components/model'
import { Defaults } from 'es-decorators'
import { spartaRefundRequestUrl } from 'init/sparta-refund-request-url'

/**
 * Модель запроса на возврат денежных средств.
 */
@Defaults({
  baseUrl: spartaRefundRequestUrl,
  urlRoot: '',
  urlPartTypes: {
    FETCH: '/refund-last-bank-detail/',
    REPEAT: '/pin-repeat',
  },
  xhrFieldsOption: {
    xhrFields: {
      withCredentials: true,
    },
  },
})
export class RefundModel extends Model {
  /**
   * @inheritDoc
   */
  save (data, options = {}) {
    this.setUrlRoot({})
    super.save(data, { ...this.xhrFieldsOption, ...options })
  }

  /**
   * Запрос последних сохранённых данных для заданного контрагента
   * @param {number} counterpartyId - Идентификатор контрагента
   */
  fetchLastSavedData (counterpartyId) {
    this.setUrlRoot({
      param: counterpartyId,
      urlPart: this.urlPartTypes.FETCH,
    })
    this.fetch(this.xhrFieldsOption)
  }

  /**
   * Повторный запрос PIN.
   */
  requestNewPin () {
    this.setUrlRoot({ urlPart: this.urlPartTypes.REPEAT })
    this.fetch(this.xhrFieldsOption)
  }

  /**
   * Устанавливает url запроса.
   * @param {string} param - параметры, которые необходимо добавить к url.
   * @param {string} urlPart - дополнение к базовому url.
   */
  setUrlRoot ({ param = '', urlPart = '' }) {
    this.urlRoot = `${this.baseUrl}${urlPart}${param}`
  }
}
